// Dashboard Stats
export const dashboardStats = {
  totalUsers: 2500,
  newUsersToday: 65,
  totalRevenue: 126500,
  revenueGrowth: 12.5,
  activeUsers: 1840,
  activeUsersGrowth: 8.2,
  premiumUsers: 850,
  premiumUsersGrowth: 15.3,
  averageSessionTime: 18.5,
  sessionsPerUser: 4.2
};

// Recent Activity
export const recentActivity = [
  {
    id: 1,
    title: 'New Premium Subscription',
    description: 'User John Doe upgraded to Premium plan',
    time: '15 minutes ago',
    type: 'subscription'
  },
  {
    id: 2,
    title: 'New User Registration',
    description: 'Amy Johnson created a new account',
    time: '1 hour ago',
    type: 'registration'
  },
  {
    id: 3,
    title: 'Voice Command Added',
    description: 'New command "Play sleep music" was added',
    time: '3 hours ago',
    type: 'feature'
  },
  {
    id: 4,
    title: 'Pet Store Purchase',
    description: 'User Mark Wilson purchased new pet accessories',
    time: '5 hours ago',
    type: 'purchase'
  },
  {
    id: 5,
    title: 'System Update',
    description: 'System successfully updated to version 2.4.0',
    time: '1 day ago',
    type: 'system'
  },
  {
    id: 6,
    title: 'Support Ticket Resolved',
    description: 'Issue with voice recognition has been fixed',
    time: '1 day ago',
    type: 'support'
  },
  {
    id: 7,
    title: 'New App Review',
    description: 'Pet Perfect app received a 5-star review',
    time: '2 days ago',
    type: 'review'
  }
];

// Monthly Revenue Data
export const monthlyRevenue = [
  { month: 'Jan', revenue: 18500 },
  { month: 'Feb', revenue: 19200 },
  { month: 'Mar', revenue: 21000 },
  { month: 'Apr', revenue: 22500 },
  { month: 'May', revenue: 24800 },
  { month: 'Jun', revenue: 27800 }
];

// User Data
export const users = [
  {
    id: '1',
    name: 'John Doe',
    email: 'john.doe@example.com',
    phone: '+1 (555) 123-4567',
    location: 'New York, USA',
    status: 'active',
    subscriptionStatus: 'premium',
    joinDate: '2024-09-15T08:30:00Z',
    lastLogin: '2025-04-23T09:15:00Z',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg'
  },
  {
    id: '2',
    name: 'Amy Johnson',
    email: 'amy.johnson@example.com',
    phone: '+1 (555) 234-5678',
    location: 'Los Angeles, USA',
    status: 'active',
    subscriptionStatus: 'free',
    joinDate: '2024-11-03T14:20:00Z',
    lastLogin: '2025-04-22T18:45:00Z',
    avatar: 'https://randomuser.me/api/portraits/women/68.jpg'
  },
  {
    id: '3',
    name: 'Mark Wilson',
    email: 'mark.wilson@example.com',
    phone: '+1 (555) 345-6789',
    location: 'Chicago, USA',
    status: 'active',
    subscriptionStatus: 'premium',
    joinDate: '2024-08-22T11:10:00Z',
    lastLogin: '2025-04-23T10:30:00Z',
    avatar: 'https://randomuser.me/api/portraits/men/45.jpg'
  },
  {
    id: '4',
    name: 'Sarah Lee',
    email: 'sarah.lee@example.com',
    phone: '+1 (555) 456-7890',
    location: 'Boston, USA',
    status: 'inactive',
    subscriptionStatus: 'free',
    joinDate: '2024-10-05T09:45:00Z',
    lastLogin: '2025-03-15T13:20:00Z',
    avatar: 'https://randomuser.me/api/portraits/women/22.jpg'
  },
  {
    id: '5',
    name: 'James Brown',
    email: 'james.brown@example.com',
    phone: '+1 (555) 567-8901',
    location: 'San Francisco, USA',
    status: 'active',
    subscriptionStatus: 'premium',
    joinDate: '2024-07-18T15:30:00Z',
    lastLogin: '2025-04-21T08:45:00Z',
    avatar: 'https://randomuser.me/api/portraits/men/75.jpg'
  },
  {
    id: '6',
    name: 'Emily Davis',
    email: 'emily.davis@example.com',
    phone: '+1 (555) 678-9012',
    location: 'Seattle, USA',
    status: 'active',
    subscriptionStatus: 'free',
    joinDate: '2025-01-09T10:15:00Z',
    lastLogin: '2025-04-22T16:10:00Z',
    avatar: 'https://randomuser.me/api/portraits/women/33.jpg'
  },
  {
    id: '7',
    name: 'Michael Clark',
    email: 'michael.clark@example.com',
    phone: '+1 (555) 789-0123',
    location: 'Denver, USA',
    status: 'active',
    subscriptionStatus: 'free',
    joinDate: '2024-12-11T13:40:00Z',
    lastLogin: '2025-04-20T09:30:00Z',
    avatar: 'https://randomuser.me/api/portraits/men/22.jpg'
  },
  {
    id: '8',
    name: 'Jennifer Wright',
    email: 'jennifer.wright@example.com',
    phone: '+1 (555) 890-1234',
    location: 'Miami, USA',
    status: 'suspended',
    subscriptionStatus: 'premium',
    joinDate: '2024-09-28T11:20:00Z',
    lastLogin: '2025-04-15T14:50:00Z',
    avatar: 'https://randomuser.me/api/portraits/women/17.jpg'
  },
  {
    id: '9',
    name: 'Robert Taylor',
    email: 'robert.taylor@example.com',
    phone: '+1 (555) 901-2345',
    location: 'Austin, USA',
    status: 'active',
    subscriptionStatus: 'premium',
    joinDate: '2024-08-05T09:10:00Z',
    lastLogin: '2025-04-23T11:25:00Z',
    avatar: 'https://randomuser.me/api/portraits/men/11.jpg'
  },
  {
    id: '10',
    name: 'Jessica Adams',
    email: 'jessica.adams@example.com',
    phone: '+1 (555) 012-3456',
    location: 'Portland, USA',
    status: 'active',
    subscriptionStatus: 'free',
    joinDate: '2025-02-17T16:30:00Z',
    lastLogin: '2025-04-22T10:15:00Z',
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg'
  }
];

// Role Data
export const roles = [
  {
    id: '1',
    name: 'Admin',
    description: 'Full system access and control',
    permissions: [
      'users:read',
      'users:write',
      'users:delete',
      'roles:read',
      'roles:write',
      'roles:delete',
      'subscriptions:read',
      'subscriptions:write',
      'subscriptions:delete',
      'petstore:read',
      'petstore:write',
      'petstore:delete',
      'ads:read',
      'ads:write',
      'ads:delete',
      'voicecommands:read',
      'voicecommands:write',
      'voicecommands:delete',
      'notifications:read',
      'notifications:write',
      'notifications:delete',
      'cms:read',
      'cms:write',
      'cms:delete',
      'settings:read',
      'settings:write'
    ],
    usersWithRole: 3,
    createdAt: '2024-05-10T08:00:00Z'
  },
  {
    id: '2',
    name: 'User Manager',
    description: 'Manage user accounts and subscriptions',
    permissions: [
      'users:read',
      'users:write',
      'subscriptions:read',
      'subscriptions:write',
      'notifications:read',
      'notifications:write'
    ],
    usersWithRole: 5,
    createdAt: '2024-05-10T08:30:00Z'
  },
  {
    id: '3',
    name: 'Content Manager',
    description: 'Manage voice commands and CMS content',
    permissions: [
      'users:read',
      'voicecommands:read',
      'voicecommands:write',
      'cms:read',
      'cms:write'
    ],
    usersWithRole: 8,
    createdAt: '2024-05-10T09:00:00Z'
  },
  {
    id: '4',
    name: 'Store Manager',
    description: 'Manage pet store items and inventory',
    permissions: [
      'users:read',
      'petstore:read',
      'petstore:write',
      'petstore:delete',
      'notifications:read',
      'notifications:write'
    ],
    usersWithRole: 4,
    createdAt: '2024-05-10T09:30:00Z'
  },
  {
    id: '5',
    name: 'Marketing Manager',
    description: 'Manage advertisements and promotions',
    permissions: [
      'users:read',
      'ads:read',
      'ads:write',
      'notifications:read',
      'notifications:write'
    ],
    usersWithRole: 6,
    createdAt: '2024-05-10T10:00:00Z'
  },
  {
    id: '6',
    name: 'Support Agent',
    description: 'Handle customer inquiries and support',
    permissions: [
      'users:read',
      'subscriptions:read',
      'petstore:read',
      'voicecommands:read'
    ],
    usersWithRole: 12,
    createdAt: '2024-05-10T10:30:00Z'
  },
  {
    id: '7',
    name: 'Viewer',
    description: 'Read-only access to all areas',
    permissions: [
      'users:read',
      'roles:read',
      'subscriptions:read',
      'petstore:read',
      'ads:read',
      'voicecommands:read',
      'notifications:read',
      'cms:read',
      'settings:read'
    ],
    usersWithRole: 7,
    createdAt: '2024-05-10T11:00:00Z'
  }
];

// Subscription Data
export const subscriptions = [
  {
    id: '1',
    name: 'Free',
    description: 'Basic access to pet care features',
    price: 0,
    currency: 'USD',
    billingCycle: null,
    status: 'active',
    features: [
      'Basic pet profile',
      'Health reminders',
      'Limited voice commands',
      'Ad-supported experience'
    ],
    userCount: 1500,
    createdAt: '2024-05-10T08:00:00Z'
  },
  {
    id: '2',
    name: 'Basic',
    description: 'Enhanced features for better pet care',
    price: 4.99,
    currency: 'USD',
    billingCycle: 'monthly',
    status: 'active',
    features: [
      'Everything in Free',
      'Advanced pet profiles',
      'Detailed health tracking',
      'More voice commands',
      'Ad-free experience'
    ],
    userCount: 650,
    createdAt: '2024-05-10T08:30:00Z'
  },
  {
    id: '3',
    name: 'Premium',
    description: 'Complete pet care solution',
    price: 9.99,
    currency: 'USD',
    billingCycle: 'monthly',
    status: 'active',
    features: [
      'Everything in Basic',
      'Multiple pet profiles',
      'Vet consultation access',
      'Custom voice commands',
      'Personalized care recommendations',
      'Priority support'
    ],
    userCount: 350,
    createdAt: '2024-05-10T09:00:00Z'
  },
  {
    id: '4',
    name: 'Family',
    description: 'Ideal for households with multiple pets',
    price: 14.99,
    currency: 'USD',
    billingCycle: 'monthly',
    status: 'active',
    features: [
      'Everything in Premium',
      'Unlimited pet profiles',
      'Family sharing (up to 5 users)',
      'Pet-to-pet interactions',
      'Advanced analytics and insights',
      '24/7 priority support'
    ],
    userCount: 200,
    createdAt: '2024-05-10T09:30:00Z'
  },
  {
    id: '5',
    name: 'Basic Annual',
    description: 'Basic subscription with annual billing',
    price: 49.99,
    currency: 'USD',
    billingCycle: 'yearly',
    status: 'active',
    features: [
      'Same features as Basic',
      'Save $9.89 compared to monthly'
    ],
    userCount: 150,
    createdAt: '2024-05-10T10:00:00Z'
  },
  {
    id: '6',
    name: 'Premium Annual',
    description: 'Premium subscription with annual billing',
    price: 99.99,
    currency: 'USD',
    billingCycle: 'yearly',
    status: 'active',
    features: [
      'Same features as Premium',
      'Save $19.89 compared to monthly',
      'Exclusive annual subscriber perks'
    ],
    userCount: 120,
    createdAt: '2024-05-10T10:30:00Z'
  },
  {
    id: '7',
    name: 'Family Annual',
    description: 'Family subscription with annual billing',
    price: 149.99,
    currency: 'USD',
    billingCycle: 'yearly',
    status: 'active',
    features: [
      'Same features as Family',
      'Save $29.89 compared to monthly',
      'Exclusive annual subscriber perks'
    ],
    userCount: 80,
    createdAt: '2024-05-10T11:00:00Z'
  },
  {
    id: '8',
    name: 'Enterprise',
    description: 'Custom solution for pet businesses',
    price: null, // Custom pricing
    currency: 'USD',
    billingCycle: 'custom',
    status: 'active',
    features: [
      'Everything in Family',
      'API access',
      'Custom branding',
      'Dedicated account manager',
      'Advanced analytics dashboard',
      'Custom feature development'
    ],
    userCount: 15,
    createdAt: '2024-05-10T11:30:00Z'
  }
];

// Ads Settings
export const adsSettings = {
  enabled: true,
  frequencyCapping: {
    maxImpressions: 5,
    timeWindow: 'hour'
  },
  adCategories: {
    petFood: true,
    petToys: true,
    petGrooming: true,
    petHealth: true,
    other: false
  },
  placementSettings: {
    homeScreen: {
      enabled: true,
      format: 'banner'
    },
    petProfile: {
      enabled: false,
      format: 'none'
    },
    activityFeed: {
      enabled: true,
      format: 'native'
    },
    storeSection: {
      enabled: true,
      format: 'interstitial'
    }
  },
  targeting: {
    locationBased: true,
    petTypeBased: true,
    userBehaviorBased: true
  },
  monetization: {
    minimumCPM: 2.5,
    preferredPartners: ['PetCo', 'PetSmart', 'RoyalCanin']
  }
};